export const GET_DOMAIN_BRAND_IDENTITY_REQUEST = 'GET_DOMAIN_BRAND_IDENTITY_REQUEST';
export const GET_DOMAIN_BRAND_IDENTITY_SUCCESS = 'GET_DOMAIN_BRAND_IDENTITY_SUCCESS';
export const GET_DOMAIN_BRAND_IDENTITY_FAILURE = 'GET_DOMAIN_BRAND_IDENTITY_FAILURE';
